import {
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Paper,
} from '@mui/material';
import { AddLocationAlt, LocationOnRounded } from '@mui/icons-material';
import InfoIcon from '@mui/icons-material/Info';
import ListIcon from '@mui/icons-material/List';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom'; // Added for URL navigation
import { useValue } from '../context/ContextProvider';
import isAdmin from '../pages/dashboard/utils/isAdmin';

const BottomNav = () => {
  const {
    state: { section, currentUser },
    dispatch,
  } = useValue();
  
  const ref = useRef();
  const navigate = useNavigate(); // Hook for navigation

  // Update URL whenever the section state changes
  useEffect(() => {
    if (isAdmin(currentUser)) {
      const paths = ['/', '/points', '/ucipoints', '/about'];
      navigate(paths[section]);
    } else {
      const paths = ['/', '/points', '/ucipoints', '/about'];
      navigate(paths[section]);
    }
    
    if (ref.current) {
      ref.current.ownerDocument.body.scrollTop = 0;
    }
  }, [section, currentUser, navigate]);

  return (
    <Box ref={ref}>
      {/* 
          COMPONENT MAPPING REMOVED FROM HERE 
          Content is now rendered via <Outlet /> in Home.js 
      */}
      <Paper
        elevation={3}
        sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 2 }}
      >
        <BottomNavigation
          showLabels
          value={section}
          onChange={(e, newValue) =>
            dispatch({ type: 'UPDATE_SECTION', payload: newValue })
          }
        >    
          <BottomNavigationAction label="Map" icon={<LocationOnRounded />} />
          <BottomNavigationAction label="Points" icon={<ListIcon />} />
          <BottomNavigationAction label="UCI Points" icon={<FormatListNumberedIcon />} />
          
          {isAdmin(currentUser) ? [

            <BottomNavigationAction key="about" label="About Us" icon={<InfoIcon />} />
          ] : (
            <BottomNavigationAction label="About Us" icon={<InfoIcon />} />
          )}
        </BottomNavigation>
      </Paper>
    </Box>
  ); 
};

export default BottomNav;


